<template>
  <div class="video-speeder-panel">
    <div class="title">
      变速列表
    </div>
    <div class="list-wrapper">
      <ul
        v-if="items && items.length"
        class="items"
      >
        <li
          v-for="(item, key) in items"
          :key="key"
          class="item"
        >
          <div class="figure">
            <img
              :src="getCover(item)"
              alt
            >
            <div
              class="play-btn"
              @click="playItem(item)"
            >
              <iconfont
                name="#icon11-11zantingbofanganniu"
                font-size="12px"
              ></iconfont>
            </div>
            <div
              class="remove-btn"
              @click="removeItem(item)"
            >
              <iconfont
                class="inactive"
                name="#icon12-12shanchu"
                font-size="12px"
              ></iconfont>
              <iconfont
                class="active"
                name="#icon12-12shanchujiaohu"
                font-size="12px"
              ></iconfont>
            </div>
            <div class="duration">
              {{ $.secToMin(item.duration) }}
            </div>
          </div>
          <div class="caption">
            <text-show-tip :text="item.name"></text-show-tip>
          </div>
        </li>
      </ul>
      <div
        v-else
        class="empty"
      >
        还没有任何作品哦
      </div>
    </div>
    <div
      v-if="items && items.length"
      class="footer"
    >
      <div
        class="clear-btn"
        @click="clearItems"
      >
        <i class="icon-wrapper">
          <iconfont
            class="inactive"
            name="#icon12-12shanchu"
            font-size="12px"
          ></iconfont>
          <iconfont
            class="active"
            name="#icon12-12shanchujiaohu"
            font-size="12px"
          ></iconfont>
        </i>
        <span>清空列表</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import TextShowTip from '@/components/common/textShowTip.vue';

export default {
  components: {
    TextShowTip
  },
  data() {
    return {
      Blob: Blob
    };
  },
  computed: {
    ...mapGetters({
      items: 'videoSpeeder/getCompletedFiles'
    })
  },
  methods: {
    playItem(item) {
      let cover = item.cover instanceof Blob ? URL.createObjectURL(item.cover) : this.$.handleAssetsUrl(item.cover);
      this.$modal.show('videoPlayModal', { ...item, cover });
    },
    removeItem(item) {
      this.$modal.show('MessageDialog', {
        content: '是否确认删除该文件？',
        btns: ['Cancel', 'Ok', 'Close'],
        size: { width: 478, height: 184 },
        resultHandler: (value) => {
          if (!value) return;
          if (value.type == 'Ok') {
            URL.revokeObjectURL(item.objectURL);
            this.$store.commit('videoSpeeder/deleteFile', item);
          }
        }
      });
    },
    clearItems() {
      this.$modal.show('MessageDialog', {
        content: '是否确定要清空当前的列表内容？（操作不可恢复）',
        size: { width: 478, height: 184 },
        btns: ['Cancel', 'Ok', 'Close'],
        resultHandler: (value) => {
          if (!value) return;
          if (value.type == 'Ok') {
            this.items.forEach((item) => {
              URL.revokeObjectURL(item.objectURL);
            });
            this.$store.commit('videoSpeeder/clearFiles');
          }
        }
      });
    },
    getCover(item) {
      // let cover = ( item.cover && (typeof item.cover === 'string') ) ? this.$.handleAssetsUrl(item.cover) : (item.coverUrl || item.cover);
      let cover = item.cover instanceof Blob ? URL.createObjectURL(item.cover) : this.$.handleAssetsUrl(item.cover);
      item.objectURL = cover;
      return cover;
    }
  }
};
</script>

<style lang="scss" scoped>
.video-speeder-panel {
  display: flex;
  flex-direction: column;
  position: relative;
  width: 326px;
  height: 100%;
  background-color: #fff;
  box-shadow: 1px 10px 20px 0px rgba(90, 98, 180, 0.1);
}
.title {
  flex-shrink: 0;
  padding-top: 30px;
  padding-left: 33px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #343434;
  text-align: left;
}
.list-wrapper {
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100% - 46px - 50px);
}
.empty {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  margin-top: -46px;
}
.items {
  width: 100%;
  height: 100%;
  padding-top: 23px;
  overflow: auto;
}
.item {
  width: 260px;
  margin-left: 33px;
  margin-bottom: 24px;

  & .figure {
    position: relative;
    width: 260px;
    height: 147px;
    border-radius: 4px;
    background: #f2f4f8;
    border: 1px solid #d7d7d7;

    &:before {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background-color: rgba(#000, 0.2);
      z-index: 10;
      opacity: 0;
    }
    &:hover:before {
      opacity: 1;
    }
    & .play-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 50%;
      left: 50%;
      z-index: 100;
      transform: translate(-50%, -50%);
      width: 44px;
      height: 44px;
      background: #ffffff;
      border-radius: 50%;
      color: #2f58fe;
      opacity: 0;
    }
    & .remove-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 10px;
      right: 10px;
      z-index: 100;
      width: 30px;
      height: 30px;
      background: rgba(#ffffff, 0.8);
      border-radius: 15px;
      opacity: 0;
      & > .active {
        display: none;
      }
      & > .inactive {
        display: block;
      }
      &:hover {
        background: #ffffff;
        & > .active {
          display: block;
        }
        & > .inactive {
          display: none;
        }
      }
    }
    & .duration {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      bottom: 9px;
      right: 9px;
      z-index: 100;
      width: 50px;
      height: 21px;
      background: rgba(#000000, 0.6);
      border-radius: 4px;
      font-size: 12px;
      font-weight: 400;
      color: #ffffff;
    }
    & > img {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      z-index: 0;
      margin: auto;
      width: auto;
      height: auto;
      max-width: 100%;
      max-height: 100%;
    }
  }
  & .figure:hover {
    & .play-btn {
      opacity: 0.8;
      cursor: pointer;
    }
    & .remove-btn {
      opacity: 1;
      cursor: pointer;
    }
  }
  & .caption {
    padding-top: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.footer {
  flex-shrink: 0;
  height: 50px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 33px;
}
.clear-btn {
  display: flex;
  align-items: center;
  cursor: pointer;
  & > span {
    padding-left: 6px;
    font-size: 14px;
    color: #343434;
  }
}
.clear-btn {
  & .active {
    display: none;
  }
  & .inactive {
    display: block;
  }
  &:hover {
    background: #ffffff;
    & .active {
      display: block;
    }
    & .inactive {
      display: none;
    }
  }
}
</style>
